import { Component, OnInit, Input } from '@angular/core';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CatalogsService } from '../../services/catalogs/catalogs.service';
import { GeneralService } from './../../services/admin/general.service';
import { RegimenFiscalService } from '../../services/regimen-fiscal/regimen-fiscal.service';
import { StorageService } from '../../services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { AddRegimenFiscalModalComponent } from './add-modal/add-modal.component';

@Component({
  selector: 'app-regimen-fiscal',
  templateUrl: './regimen-fiscal.component.html',
  styleUrls: ['./regimen-fiscal.component.scss'],
  providers: [GeneralService, RegimenFiscalService]
})
export class CrudRegimenFiscalComponent implements OnInit {
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  rows = [];
  rowsTmp = [];
  loading: boolean = true;
  regimenFiscalFiltro: any = '';
  regimenFiscal: any[] = [];
  modalRespuesta;

  toastRegistroDe;
  constructor(
    private translate: TranslateService,
    private modalService: NgbModal,
    private general: GeneralService,
    private regimenFiscalService: RegimenFiscalService,
    private toasterService: ToasterService,
    private catalogService: CatalogsService,
    private storageService: StorageService

  ) {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastRegistroDe').subscribe(
      text => {
        this.toastRegistroDe = text;
      }); 

    // this.translate.get('texto.monedaEliminada').subscribe(
    //   text => {
    //     this.monedaEliminada = text;
    //   });

    // this.translate.get('texto.errorEliminarMoneda').subscribe(
    //   text => {
    //     this.errorEliminarMoneda = text;
    //   });
  }

  ngOnInit() {
    this.noBack();
    this.modulo();
    this.obtenerListaRegimenFiscal();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('REGIMEN FISCAL RECEPTOR').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  obtenerListaRegimenFiscal() {
    this.rows = [];

    this.loading = true;
    this.regimenFiscalService.getRegimenFiscalLista().subscribe(
      data => {
        this.rows = data.regimenFiscal;
        this.rowsTmp = data.regimenFiscal;
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.toasterService.pop('error', 'Error', err.message);
      },
    );
  }

  obtenerRegimenFiscal() {
    if (this.regimenFiscalFiltro.trim() !== '') {
      this.regimenFiscal = [];

      this.loading = true;
      this.regimenFiscalService.getRegimenFiscalPorRFC(this.regimenFiscalFiltro).subscribe(
        data => { 
  
          if (data.regimenFiscal['id'] !== 0) {
            this.regimenFiscal.push(data.regimenFiscal)
          } 
  
          this.regimenFiscal = [...this.regimenFiscal];
          this.rows = [...this.regimenFiscal];
          this.loading = false;
        },
        err => {
          this.loading = false;
        },
      );
    } else {
      this.rows = [...this.rowsTmp];
    }
  }

  openModalRegistro(row) {
    const modalRef = this.modalService.open(AddRegimenFiscalModalComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.row = row;
    modalRef.result.then(
      (result) => {
          if (result === 'success') {
            this.obtenerListaRegimenFiscal();
          } 
      }
    )
    .catch((error) => {
        // console.log(error);
    });

  }

  borrarRegimenFiscal(row) {
      this.loading = true;
      this.regimenFiscalService.deleteRegimenFiscal(row.id).subscribe(
        data => { 
          let response = data.result;

          if (response.estatus === 'S') {
            this.toasterService.pop('success', '', response.mensaje);
            this.obtenerListaRegimenFiscal();
          } else {
            this.toasterService.pop('error', 'Error', response.mensaje);
          }

          this.loading = false;
        },
        err => {
          this.loading = false;
        },
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/regimen-fiscal/regimen-fiscal.component.ts